import configs from 'config/environment'

export const authRequest = async data => {
  const { email, password } = data

  return new Promise(async (resolve, reject) => {
    try {
      const res = await fetch(
        `${configs.localAppUrl}index.php?entryPoint=AuthApi`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email, password })
        }
      )

      if (!res.ok) {
        throw new Error(`Network response was not ok: ${res.statusText}`)
      }

      const parsed = await res.json()

      if (parsed.success) {
        localStorage.setItem('token', parsed.access_token)
        resolve(parsed)
      } else {
        reject({
          error: 'authError',
          error_description: parsed.message || 'Authentication failed'
        })
      }
    } catch (err) {
      reject({
        error: 'networkError',
        error_description: err.message || 'Network error occurred'
      })
    }
  })
}
